import React, { useEffect, useRef, useState } from "react";
import Loader from "./Loader";
import moment from "moment";
import { Switch } from "antd";
import { clog } from "../lib/utils";

const MonthlyCalenderTable = ({
  monthlyData,
  loadingMonthlyData,
  monthlyDataError,
  setmonthlyData,
  monthlyDataEdit,
  setmonthlyDataEdit,
  selectedRows,
  setSelectedRows,
  saveMonthlyCalenderDataTitle,
  savingTitle,
  setSavingTitle,
  changingStatus,
  disableAllactionsForYear,
}) => {
  // clog(savingTitle, "savingTitle");
  clog("monthlyData", monthlyData);
  clog("monthlyDataEdit", monthlyDataEdit);
  // const [selectedRows, setSelectedRows] = useState([]);
  const [editingTitle, setEditingTitle] = useState({});
  const [editingRow, setEditingRow] = useState(null);
  const [editingKeywordsRow, setEditingKeywordsRow] = useState(null);
  const popupRef = useRef(null);
  const popupRefKeywords = useRef(null);
  const rows = [1, 2, 3, 4, 5, 6];

  const isAllSelected = selectedRows.length === monthlyData?.length;

  // Select all or deselect all
  const handleHeaderCheckbox = () => {
    if (isAllSelected) {
      let approvalIds = monthlyData
        ?.filter((item) => item?.status >= 2)
        ?.map((item) => item?._id);
      setSelectedRows(approvalIds || []);
    } else {
      // Select all visible rows (based on current data)
      const allRowIds = monthlyData?.map((row) => row?._id);
      setSelectedRows(allRowIds);
    }
  };

  // Toggle a single row's selection
  const handleRowCheckbox = (row, index, isSelected) => {
    if (row?.status >= 2) {
      return;
    }
    setSelectedRows((prevSelected) =>
      prevSelected.includes(row?._id)
        ? prevSelected.filter((rowId) => rowId !== row?._id)
        : [...prevSelected, row?._id]
    );
    if (!isSelected)
      setmonthlyDataEdit((prevData) =>
        prevData.map((item) =>
          item._id === row?._id
            ? {
                ...item,
                title: monthlyData[index]?.title,
                suggested_keywords:
                  monthlyData[index]?.suggested_keywords?.join(","),
                edit: false,
              }
            : item
        )
      );
  };
  const handleEdit = (id, key, value) => {
    setmonthlyDataEdit((prevData) =>
      prevData.map((item) =>
        item._id === id ? { ...item, [key]: value, edit: true } : item
      )
    );
  };
  const onRerun = (id) => {
    clog("Rerun for ID:", id);
  };
  const onTitleUpdate = (id, newTitle) => {};

  const handleTitleSave = (id) => {
    if (editingTitle[id]) {
      onTitleUpdate(id, editingTitle[id]);
    }
  };
  const STATUS_OPTIONS = {
    1: { label: "Initiated", color: "bg-yellow-100 text-yellow-800" },
    2: { label: "Approved", color: "bg-blue-100 text-blue-800" },
    3: { label: "Content Generated", color: "bg-purple-100 text-purple-800" },
    4: { label: "Published", color: "bg-green-100 text-green-800" },
  };

  clog("selectedRows", selectedRows);

  useEffect(() => {
    if (editingRow !== null) {
      const handleClickOutside = (event) => {
        if (popupRef.current && !popupRef.current.contains(event.target)) {
          const index = monthlyData.findIndex(
            (item) => item._id === editingRow
          );
          // saveMonthlyCalenderDataTitle(
          //   {
          //     id: editingRow,
          //     title: monthlyDataEdit[index]?.title,
          //     // suggested_keywords: monthlyDataEdit[index]?.suggested_keywords
          //     //   ?.split(",")
          //     //   ?.map((keyword) => keyword.trim()),
          //   },
          //   "title"
          // );
          setEditingRow(null);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }
  }, [editingRow, monthlyData, monthlyDataEdit]);
  useEffect(() => {
    if (!savingTitle) {
      setEditingRow(null);
      setEditingKeywordsRow(null);
    }
  }, [savingTitle]);

  // Handle outside click for Keywords popup
  useEffect(() => {
    if (editingKeywordsRow !== null) {
      const handleClickOutside = (event) => {
        if (
          popupRefKeywords.current &&
          !popupRefKeywords.current.contains(event.target)
        ) {
          // const index = monthlyData.findIndex(
          //   (item) => item._id === editingKeywordsRow
          // );
          // saveMonthlyCalenderDataTitle(
          //   {
          //     id: editingKeywordsRow,
          //     // title: monthlyDataEdit[index]?.title,
          //     suggested_keywords: monthlyDataEdit[index]?.suggested_keywords
          //       ?.split(",")
          //       ?.map((keyword) => keyword.trim()),
          //   },
          //   "keywords"
          // );
          setEditingKeywordsRow(null);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }
  }, [editingKeywordsRow, monthlyData, monthlyDataEdit]);
  const scrollRef = useRef(null);
  const [roundedTopRow, setRoundedTopRow] = useState(false);
  const isDateGreaterThanToday = (date) => {
    if (!date) return false;
    const today = moment().startOf("day");
    const postDate = moment(date).startOf("day");
    return postDate.isSameOrAfter(today);
  };

  useEffect(() => {
    const container = scrollRef.current;

    const handleScroll = () => {
      // Detect how much the container has scrolled
      const scrollTop = container.scrollTop;
      // Apply rounding if scrolled down a bit
      setRoundedTopRow(scrollTop > 5);
    };

    container?.addEventListener("scroll", handleScroll);
    return () => container?.removeEventListener("scroll", handleScroll);
  }, []);
  const pathname = window?.location?.pathname;
  return (
    // <div className="monthly-calender-container mt-5 overflow-auto">
    <div
      className={`monthly-calender-container mt-5 overflow-y-auto relative bg-white ${
        pathname === "/monthly-calendar"
          ? "h-[calc(100vh-100px)]"
          : "h-[calc(100vh-230px)]"
      } `}
    >
      {loadingMonthlyData && (
        <div className="w-full h-full flex justify-center items-center">
          <Loader />
        </div>
      )}
      {!loadingMonthlyData && monthlyData?.length > 0 && (
        <table
          className="table-auto border w-full"
          style={
            {
              // overflowY: "auto",
            }
          }
        >
          <thead className="sticky top-0 z-20">
            <tr className="h-16">
              <th className="w-[50px] px-2">
                <input
                  type="checkbox"
                  checked={isAllSelected}
                  onChange={handleHeaderCheckbox}
                  disabled={disableAllactionsForYear()}
                  className="disabled:opacity-50"
                />
              </th>
              <th className="w-[50px] px-2">S.No</th>
              <th className="w-[250px] px-2">Title</th>
              <th className="w-[150px] px-2">Intent</th>
              <th className="w-[250px] px-2">Painpoints</th>
              <th className="w-[250px] px-2">Keywords</th>
              <th className="w-[180px] px-2">Generation Status</th>
              <th className="w-[200px] px-2">Generation Date</th>
              {pathname.includes("monthly-calendar") && (
                <th className="w-[100px] px-2">Assigned To</th>
              )}
            </tr>
          </thead>
          <tbody className="w-[85%]">
            {monthlyData?.map((item, index) => {
              const isSelected = selectedRows.includes(item?._id);
              return (
                <tr key={item?._id} className="h-[72px] overflow-hidden">
                  <td className="w-[50px] px-2 align-top">
                    <input
                      type="checkbox"
                      className="disabled:opacity-50"
                      checked={isSelected}
                      onChange={() =>
                        handleRowCheckbox(item, index, isSelected)
                      }
                      disabled={disableAllactionsForYear() || item?.status >= 2}
                    />
                  </td>
                  <td className="w-[50px] px-2 align-top">{index + 1}</td>
                  {/* <td className="w-[100px] px-2 align-top">
                    <button
                      type="button"
                      className="py-1 px-3 rounded-full text-sm font-semibold ring-[1px] ring-[#2A2A2A] ring-inset hover:ring-0 bg-gradient-to-r hover:from-[#1A71A7] hover:to-[#9D3784] hover:text-white transition delay-75 disabled:opacity-50"
                      disabled={
                        disableAllactionsForYear() ||
                        !isSelected ||
                        !monthlyDataEdit[index]?.edit ||
                        savingTitle === item?._id
                      }
                      onClick={() =>
                        saveMonthlyCalenderDataTitle({
                          id: item?._id,
                          title: monthlyDataEdit[index]?.title,
                          suggested_keywords: monthlyDataEdit[
                            index
                          ]?.suggested_keywords
                            ?.split(",")
                            ?.map((keyword) => keyword.trim()),
                        })
                      }
                    >
                      {savingTitle === item?._id ? <Loader /> : "Save"}
                    </button>
                  </td> */}
                  {/* <td className="w-[250px] px-2 align-top">
                    {(!item?.status || item?.status < 2) && isSelected ? (
                      <div className="">
                        <textarea
                          rows={5}
                          // cols={10}
                          value={monthlyDataEdit[index]?.title}
                          onChange={(e) =>
                            handleEdit(item?._id, "title", e.target.value)
                          }
                          className="border rounded"
                        />
                      </div>
                    ) : (
                      item?.title
                    )}
                  </td> */}
                  <td className="w-[250px] px-2 align-top relative">
                    <div className="flex items-center">
                      <div>{item?.title}</div>
                      {(!item?.status || item?.status < 2) && isSelected && (
                        <button
                          onClick={() => {
                            setEditingRow(
                              editingRow === item._id ? null : item._id
                            );
                            setmonthlyDataEdit((prevData) =>
                              prevData.map((editedItem) =>
                                editedItem?._id === item?._id
                                  ? {
                                      ...editedItem,
                                      title: monthlyData[index]?.title,
                                      suggested_keywords:
                                        monthlyData[
                                          index
                                        ]?.suggested_keywords?.join(","),
                                      edit: true,
                                    }
                                  : editedItem
                              )
                            );
                          }}
                          className="editable-cell-button "
                        >
                          <svg className="icon">
                            <use href="#icon_edit"></use>
                          </svg>
                        </button>
                      )}
                    </div>
                    {editingRow === item._id && (
                      <div
                        className="tbl-contentBox"
                        ref={popupRef}
                        style={{
                          position: "absolute",
                          zIndex: 100,
                          top: "0px",
                          left: "0px",
                          background: "#fff",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                          padding: "12px",
                          borderRadius: "8px",
                        }}
                      >
                        <textarea
                          style={{
                            minWidth: "100%",
                            minHeight: "100px",
                          }}
                          className="border rounded p-2 mb-3"
                          value={monthlyDataEdit[index]?.title}
                          onChange={(e) =>
                            handleEdit(item?._id, "title", e.target.value)
                          }
                        ></textarea>
                        <div className="flex justify-end gap-2">
                          <button
                            onClick={() => {
                              setEditingRow(null);
                            }}
                            className="px-3 py-1 rounded-full text-sm font-semibold border border-gray-300 hover:bg-gray-100"
                          >
                            Cancel
                          </button>
                          <button
                            onClick={() => {
                              saveMonthlyCalenderDataTitle(
                                {
                                  id: item._id,
                                  title: monthlyDataEdit[index]?.title,
                                },
                                "title"
                              );
                              // setEditingRow(null);
                            }}
                            className="px-3 py-1 rounded-full text-sm font-semibold text-white bg-gradient-to-r from-[#1A71A7] to-[#9D3784] hover:opacity-90"
                          >
                            {savingTitle === item?._id ? (
                              <Loader dimensions={`w-5 h-5`} />
                            ) : (
                              "Save"
                            )}
                          </button>
                        </div>
                      </div>
                    )}
                  </td>
                  <td className="w-[150px] px-2 align-top">{item?.intent}</td>
                  <td className="w-[250px] px-2 align-top">
                    {item?.painpoints?.join(", ")}
                  </td>
                  {/* <td className="w-[250px] px-2 align-top">
                    {(!item?.status || item?.status < 2) && isSelected ? (
                      <div className="">
                        <textarea
                          rows={5}
                          // cols={10}
                          value={monthlyDataEdit[index]?.suggested_keywords}
                          onChange={(e) =>
                            handleEdit(
                              item?._id,
                              "suggested_keywords",
                              e.target.value
                            )
                          }
                          className="border rounded"
                        />
                      </div>
                    ) : (
                      item?.suggested_keywords.join(", ")
                    )}
                  </td> */}
                  <td className="w-[250px] px-2 align-top relative">
                    <div className="flex items-center">
                      <div>{item?.suggested_keywords?.join(", ")}</div>
                      {(!item?.status || item?.status < 2) && isSelected && (
                        <button
                          onClick={() => {
                            setEditingKeywordsRow(
                              editingKeywordsRow === item._id ? null : item._id
                            );
                            setmonthlyDataEdit((prevData) =>
                              prevData.map((editedItem) =>
                                editedItem?._id === item?._id
                                  ? {
                                      ...editedItem,
                                      title: monthlyData[index]?.title,
                                      suggested_keywords:
                                        monthlyData[
                                          index
                                        ]?.suggested_keywords?.join(","),
                                      edit: true,
                                    }
                                  : editedItem
                              )
                            );
                          }}
                          className="editable-cell-button "
                        >
                          <svg className="icon">
                            <use href="#icon_edit"></use>
                          </svg>
                        </button>
                      )}
                    </div>
                    {editingKeywordsRow === item._id && (
                      <div
                        className="tbl-contentBox"
                        ref={popupRefKeywords}
                        style={{
                          position: "absolute",
                          zIndex: 100,
                          top: "0px",
                          left: "0px",
                          background: "#fff",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                          padding: "12px",
                          borderRadius: "8px",
                        }}
                      >
                        <textarea
                          style={{
                            minWidth: "200px",
                            minHeight: "100px",
                          }}
                          className="border rounded"
                          value={monthlyDataEdit[index]?.suggested_keywords}
                          onChange={(e) =>
                            handleEdit(
                              item?._id,
                              "suggested_keywords",
                              e.target.value
                            )
                          }
                        ></textarea>
                        <div className="flex justify-end gap-2">
                          <button
                            onClick={() => {
                              setEditingKeywordsRow(null);
                            }}
                            className="px-3 py-1 rounded-full text-sm font-semibold border border-gray-300 hover:bg-gray-100"
                          >
                            Cancel
                          </button>
                          <button
                            onClick={() => {
                              saveMonthlyCalenderDataTitle(
                                {
                                  id: item._id,
                                  suggested_keywords: monthlyDataEdit[
                                    index
                                  ]?.suggested_keywords
                                    ?.split(",")
                                    ?.map((keyword) => keyword.trim()),
                                },
                                "keywords"
                              );
                              // setEditingKeywordsRow(null);
                            }}
                            className="px-3 py-1 rounded-full text-sm font-semibold text-white bg-gradient-to-r from-[#1A71A7] to-[#9D3784] hover:opacity-90"
                          >
                            {savingTitle === item?._id ? (
                              <Loader dimensions={`w-5 h-5`} />
                            ) : (
                              "Save"
                            )}
                          </button>
                        </div>
                      </div>
                    )}
                  </td>
                  {/* <td className="w-[180px] px-2 align-top">
                    {item?.status && (
                      <span
                        className={`inline-block px-3 py-1 text-sm font-medium text-center rounded-full ${
                          STATUS_OPTIONS[item?.status]?.color
                        }`}
                      >
                        {STATUS_OPTIONS[item?.status]?.label || ""}
                      </span>
                    )}
                  </td> */}
                  <td className="w-[180px] px-2 align-top">
                    {item?.status && (
                      <div className="flex gap-2 justify-center items-center mx-auto">
                        {changingStatus === item?._id ? (
                          <Loader />
                        ) : (
                          <>
                            <div
                              className={`px-3 py-1 text-sm font-medium text-center rounded-full ${
                                STATUS_OPTIONS[item?.status]?.color
                              }`}
                            >
                              {STATUS_OPTIONS[item?.status]?.label || ""}
                            </div>
                            {pathname?.includes("ai-employee") &&
                              (item?.status == 1 || item?.status == 2) &&
                              selectedRows?.includes(item?._id) &&
                              isDateGreaterThanToday(item.post_date) && (
                                <div className="">
                                  <Switch
                                    checked={item.status >= 2}
                                    onChange={() => {
                                      if (item.status >= 2) {
                                        saveMonthlyCalenderDataTitle(
                                          {
                                            id: item._id,
                                            status: 1,
                                          },
                                          "status"
                                        );
                                      } else {
                                        saveMonthlyCalenderDataTitle(
                                          {
                                            id: item._id,
                                            status: 2,
                                          },
                                          "status"
                                        );
                                      }
                                    }}
                                    // checkedChildren="Active"
                                    // unCheckedChildren="Inactive"
                                    className={
                                      item.status >= 2
                                        ? "custom-switch-active"
                                        : "custom-switch-inactive"
                                    }
                                  />
                                </div>
                              )}
                          </>
                        )}
                      </div>
                    )}
                  </td>
                  <td className="w-[200px] px-2 align-top">
                    {item?.post_date
                      ? moment(item?.post_date)?.format("D MMMM, YYYY")
                      : ""}
                  </td>
                  {pathname.includes("monthly-calendar") && (
                    <td className="w-[100px] px-2 align-top">
                      {item?.employee?.emp_name}
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default MonthlyCalenderTable;
